module.exports = __webpack_public_path__ + "static/media/Table-7-4.2a63ae78.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/Table-7-4.svg
// module id = 769
// module chunks = 0